"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isButtonPressed = exports.ButtonStates = exports.ButtonActions = void 0;
const events_1 = require("events");
const MessageParser_1 = require("./MessageParser");
const ISerialPort_1 = require("./ISerialPort");
var ButtonActions;
(function (ButtonActions) {
    ButtonActions["Pressed"] = "pressed";
    ButtonActions["Released"] = "released";
})(ButtonActions = exports.ButtonActions || (exports.ButtonActions = {}));
var ButtonStates;
(function (ButtonStates) {
    ButtonStates[ButtonStates["PRESSED"] = 0] = "PRESSED";
    ButtonStates[ButtonStates["RELEASED"] = 1] = "RELEASED";
})(ButtonStates = exports.ButtonStates || (exports.ButtonStates = {}));
class Button extends events_1.EventEmitter {
    constructor(serialPort, address, index) {
        super();
        this.serialPort = serialPort;
        this.address = address;
        this.index = index;
        this.eventEmitter = new events_1.EventEmitter();
        this.state = ButtonStates.RELEASED;
        this.initStream();
    }
    isPressed() {
        return __awaiter(this, void 0, void 0, function* () {
            const address = this.address.toString().padStart(3, '0');
            const msg = `X${address}A[]`;
            this.serialPort.sendMessage(msg);
            const newState = yield this.waitForNextStateChange();
            return newState === ButtonActions.Pressed;
        });
    }
    initStream() {
        this.serialPort.on(ISerialPort_1.SerialPortEvent.MESSAGE, (message) => {
            try {
                const cmd = MessageParser_1.parseMessage(message);
                if (cmd.type === MessageParser_1.CommandType.XTALK
                    && cmd.address === this.address
                    && cmd.format === MessageParser_1.FormatType.SHORT) {
                    if (!isNaN(Number(cmd.command))) {
                        const value = Number(cmd.command);
                        this.handleNewState(value);
                    }
                }
            }
            catch (error) {
                if (error instanceof Error
                    && !(error instanceof MessageParser_1.InvalidArgumentError)
                    && !(error instanceof MessageParser_1.UnknownCommandError)) {
                    console.error(error.message); // eslint-disable-line no-console
                }
            }
        });
    }
    handleNewState(value) {
        if (isButtonPressed(value, this.index)) {
            this.eventEmitter.emit('state_change', ButtonActions.Pressed);
            this.handlePressed();
        }
        else {
            this.eventEmitter.emit('state_change', ButtonActions.Released);
            this.handleReleased();
        }
    }
    handlePressed() {
        if (this.state !== ButtonStates.PRESSED) {
            this.state = ButtonStates.PRESSED;
            this.emit(ButtonActions.Pressed);
        }
    }
    handleReleased() {
        if (this.state !== ButtonStates.RELEASED) {
            this.state = ButtonStates.RELEASED;
            this.emit(ButtonActions.Released);
        }
    }
    waitForNextStateChange() {
        return new Promise((resolve) => {
            this.eventEmitter.once('state_change', resolve);
        });
    }
}
/**
 *
 * @param value from the square brackets of the message
 * @param index of the Button
 * @returns `true` if the button is pressed
 */
function isButtonPressed(value, index) {
    const currentBit = (value & 1) << (index + 1);
    return !!(value & currentBit);
}
exports.isButtonPressed = isButtonPressed;
exports.default = Button;
//# sourceMappingURL=Button.js.map